import axios from 'axios'
const API_URL = process.env.REACT_APP_THEME_API_URL
const ADDRESS_VERIFICATION = `${API_URL}/app/get-address-verification`
const ADDRESS_VERIFICATION_UPDATE = `${API_URL}/app/address-update-verify-link`
const PROJECT_DATA = `${API_URL}/app/project-by-token`
const API = axios.create();

export const getAddressVerification = (data) => {
    return API.post(ADDRESS_VERIFICATION, data).then((d) => d.data);
};
export const updateAddressVerification = (data) => {
    return API.post(ADDRESS_VERIFICATION_UPDATE, data).then((d) => d.data);
};
export const getProjectByToken = (data) => {
    return API.post(PROJECT_DATA, data).then((d) => d.data);
};